import { render, staticRenderFns } from "./NaverCallback.vue?vue&type=template&id=3401fedd&scoped=true"
import script from "./NaverCallback.vue?vue&type=script&lang=js"
export * from "./NaverCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3401fedd",
  null
  
)

export default component.exports